import { useEffect, useState } from 'react';
import { imgs } from '../assets/imgs';
import { svgs } from '../assets/svgs';
import { Banner, CountDown, HSRegisterForm, TestimonialCarousel } from '../components';
import { NavLink, Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useResizeImg } from '../hooks/useResizeImg';
import { RegisterForm } from '../components/register/RegisterForm';

const deadline = new Date('November 24 2023 00:00:00 PST')
const deadline2 = new Date('December 8 2023 00:00:00 PST')
// const DISCOUNT = deadline > Date.now() ? 300 : 200
const DISCOUNT = deadline2 > Date.now() ? 200 : 0

export const Register = () => {
   document.title = "New England Venture Summit | Registration";

   const [isLoading, setIsLoading] = useState(true)
   const imageSource = useResizeImg(imgs.register.registerBannerDesktop, imgs.register.registerBannerMobile)
   const navigate = useNavigate()
   const { type } = useParams()
   const { search } = useLocation()

   const tabs = [
      { name: 'STARTUPS', bgColor: 'linear-gradient(180deg, #312948 0%, #7E5FD6 100%)', link: 'startups' + search },
      { name: 'INVESTORS', bgColor: 'linear-gradient(180deg, #106B2A 0%, #457C55 100%)', link: 'investors' + search },
      { name: 'GENERAL ATTENDEES', bgColor: 'linear-gradient(180deg, #0008C5 0%, #001C64 100%)', link: 'general' + search },
   ]

   useEffect(() => {
      if (!type) navigate('startups' + search)
   }, [type])

   useEffect(() => {
      var bz = document.createElement("script");
      bz.type = "text/javascript";
      bz.async = true;
      bz.src = "https://organizer.bizzabo.com/widgets/tickets/tickets.js";
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(bz, s);
      const script = document.createElement('script');
      script.src = 'https://js.hsforms.net/forms/v2.js';
      document.body.appendChild(script);
      script.addEventListener('load', () => {
         if (window.hbspt) {
            window.hbspt.forms.create({
               portalId: '536350',
               formId: "8b0104df-57bf-4a46-bef7-b8e2b9fad4d1",
               region: "na1",
               target: '#preregForm'
            })
         }
      });
   }, []);

   return (
      <div className='register'>
         <Banner imageSource={imageSource} isLoading={isLoading} setIsLoading={setIsLoading} >
            {DISCOUNT > 0 ?
               <>
                  <section>
                     <h2 >Get Your Tickets Now</h2>
                     <h1>Register Now and Save ${DISCOUNT}</h1>
                     <h2>Use Promo Code: early{DISCOUNT}</h2>
                     <h5>Pre-registration savings available for a limited time</h5>
                  </section>
                  <section >
                     {deadline > new Date() && < CountDown deadline={deadline} />}
                     {deadline < new Date() && deadline2 > new Date() && < CountDown deadline={deadline2} />}
                  </section>
               </>
               :
               <section>
                  {/* <h2 >Get Your Tickets Now</h2> */}
                  <h1>Register </h1>
               </section>
            }
         </Banner>
         <HSRegisterForm />
         {/* <nav>
            {
               tabs.map((tab, index) =>
                  <NavLink key={tab.link} className={type === tab.link ? 'btn b3' : 'btn b4'} style={{ background: type === tab.link && tab.bgColor }} to={tab.link}>{tab.name}</NavLink>
               )
            }
         </nav>
         <Outlet context={[DISCOUNT]} /> */}
         {/* <TestimonialCarousel pageName={"registration;"} /> */}
         {/* <RegisterForm /> */}
         {/* <div
            id="biza-prc-div"
            className="bizzabo-tickets-widget"
            data-event-id="538979"
            data-params="isInMinisite=true&widgetId=370007"
         /> */}
      </div>
   )
}

